import { CommunicationConfigService } from '@argalis-apps/angular-global';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {
  constructor(private communicationConfigService: CommunicationConfigService, private http: HttpClient) {}

  getAllPlanning(idIntervenant, startDateRange, endDateRange, bOst) {
    let params = new HttpParams();
    params = params.set('idIntervenant', idIntervenant.toString());
    params = params.set('startDateRange', startDateRange.toString());
    params = params.set('endDateRange', endDateRange.toString());
    params = params.set('bOst', (bOst || false).toString());
    return this.http.get(`${this.communicationConfigService.getApiUri()}/calendar/all-planning`, { params });
  }

  getIndispo(idIntervenant, date) {
    let params = new HttpParams();
    params = params.set('idIntervenant', idIntervenant.toString());
    params = params.set('date', date.toString());
    return this.http.get(`${this.communicationConfigService.getApiUri()}/calendar/indispo`, { params });
  }

  getSession(idIntervenant, date, bOst) {
    let params = new HttpParams();
    params = params.set('idIntervenant', idIntervenant.toString());
    params = params.set('date', date.toString());
    params = params.set('bOst', bOst.toString());
    return this.http.get(`${this.communicationConfigService.getApiUri()}/calendar/session`, { params });
  }

  getHoraireOf(idIntervenant) {
    return this.http.get(
      `${this.communicationConfigService.getApiUri()}/calendar/organisme-formation/horaire/${idIntervenant}`
    );
  }
}
